<template>
  <div class="w-full flex" v-loading="loading">
    <div class="w-4/12 p-2">
      <div class="border rounded-md px-4">
        <el-form :model="form" ref="form">
          <!-- Report Period Type -->
          <el-form-item prop="dataForm">
            <h5 class="text-base font-bold text-black mt-2">Report Period</h5>
            <el-select
              v-model="form.dataForm"
              @change="onChangePicker"
              placeholder="Select Report Period"
              class="w-full"
            >
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- Period Range -->
          <h5 class="text-base font-bold text-black my-2">Period Range</h5>
          <div class="flex justify-between">
            <el-form-item prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                :picker-options="datePickerOptions"
                :type="periodDatePickerType"
                placeholder="Start Period"
                value-format="yyyy-MM-dd"
                @change="validateDate"
                class="mr-1"
                style="width: 98%;"
              />
            </el-form-item>
            <el-form-item prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                :picker-options="datePickerOptions"
                :type="periodDatePickerType"
                placeholder="End Period"
                value-format="yyyy-MM-dd"
                @change="validateDate"
                class="ml-1"
                style="width: 98%;"
              />
            </el-form-item>
          </div>
          <!-- Type Sensor -->
          <el-form-item>
            <h5 class="text-base font-bold text-black">Sensor Type</h5>
            <el-select
              v-model="form.sensorType"
              @change="onChangeTypeSensor"
              placeholder="Select Sensor Type"
              class="w-full"
            >
              <el-option
                v-for="item in sensorTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- Dropdown Report -->
        <h5 class="text-base font-bold text-black">Sub Devices</h5>
        <!-- <el-input placeholder="Filter Keyboard" v-model="filter" size="small" class="mt-2"></el-input> -->
        <div class="border mt-2 h-56 rounded overflow-auto py-2">
          <el-tree
            class=""
            :data="checkboxes"
            show-checkbox
            node-key="id"
            @check="CheckedNodes"
            :default-expanded-keys="[]"
            :default-checked-keys="[]"
          />
        </div>

        <!-- Submit button -->
        <div class="flex mt-4 mb-4 justify-end">
          <el-button type="primary" @click="submit">Submit</el-button>
        </div>
      </div>
    </div>
    <div class="w-8/12 p-2">
      <div class="border rounded-md p-3">
        <div
          v-if="chartBarVisible"
          class="bg-white w-full flex justify-center rounded"
        >
          <bar-chart
            style="width: 100%;"
            :height="200"
            :chart-data="dataCollectionReport"
            :options="chartOptionsReport"
          />
        </div>
        <div class="mt-4">
          <table class="w-full">
            <thead>
              <tr class="bg-gray-200">
                <th class="border py-1">Sub Device Name</th>
                <th class="border py-1">Timestamp</th>
                <th class="border py-1">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) of tableData"
                :key="index"
                :class="index % 2 === 0 ? 'bg-gray-100' : ''"
              >
                <td class="border px-2 py-1">{{ item.deviceName }}</td>
                <td class="border px-2 py-1 text-right">
                  {{ item.timestamp }}
                </td>
                <td class="border px-2 py-1 text-right">
                  {{ `${item.value}${item.unit}` }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/Chart/BarChart.js'
import LineChart from '@/components/Chart/LineChart.js'
import dropdownReportJson from '@/assets/json/dropdownReport.json'
import averageReportBySubDeviceNameJson from '@/assets/json/averageReportBySubDeviceName.json'
import moment from 'moment'

export default {
  components: {
    BarChart,
    LineChart
  },
  data() {
    return {
      loading: false,
      chartBarVisible: false,
      dataCollectionReport: null,
      chartOptionsReport: {
        plugins: {
          // datalabels: {
          //   display: false,
          // },
        },
        title: {
          display: true,
          text: 'Average By Sub Device Name',
          fontSize: 17
        },
        legend: {
          // display: false,
          labels: {
            fontColor: 'black',
            usePointStyle: true
          },
          position: 'bottom'
        },
        scales: {
          yAxes: [
            {
              gridLines: { color: '#607d8b' },
              ticks: {
                fontColor: 'black',
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }
          ],
          xAxes: [
            {
              gridLines: { color: '' },
              ticks: {
                fontColor: 'black'
                // stepSize: 1,
              }
            }
          ]
        }
      },
      form: {
        startDate: '2020-11-20',
        endDate: '2020-11-25',
        reportType: '',
        dataForm: 'daily_avg',
        sensorType: ''
      },
      dateOptions: [
        {
          value: 'daily_avg',
          label: 'Daily'
        },
        {
          value: 'monthly_avg',
          label: 'Monthly'
        },
        {
          value: 'yearly_avg',
          label: 'Yearly'
        }
      ],
      sensorTypeOptions: [],
      datePickerOptions: '',
      periodDatePickerType: 'date',
      checkboxes: [],
      dropdownReport: [],
      checkedNodes: [],
      tableData: []
    }
  },
  mounted() {
    this.fetchDropdownReport()
  },
  methods: {
    createChart(data = {}) {
      // data = averageReportBySubDeviceNameJson

      const labels = data.ListLabel
      const datalist = data.AverageHistorical.map((item) => item.DecimalVal)
      this.chartOptionsReport.scales.yAxes[0].scaleLabel.labelString =
        data.AverageHistorical[0]?.Unit

      this.dataCollectionReport = {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: `Average of ${this.form.sensorType}`,
            backgroundColor: '#6199CC',
            borderColor: '#6199CC',
            strokeColor: '#79D1CF',
            data: datalist,
            fill: false,
            pointRadius: 3
          }
        ]
      }

      // console.log('inimang', data)
    },
    async submit() {
      this.loading = true

      try {
        if (this.form.startDate === '' || this.form.endDate === '') {
          this.$message.error('Please choose date correctly')
          this.loading = false
          return
        } else if (this.form.sensorType === '') {
          this.$message.error('Please choose sensor type first')
          this.loading = false
          return
        } else if (this.checkedNodes.length < 1) {
          this.$message.error('Please check any sub device first')
          this.loading = false
          return
        }

        const data = {
          dataForm: this.form.dataForm,
          typeSensor: this.form.sensorType,
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          SubDeviceName: [...this.checkedNodes.map((item) => item.label)]
        }

        const res = await this.$axios.post(
          'Report/PostCreateAverageReportBySubDeviceName',
          data
        )

        let historicalValues = []

        res.data?.ListOfSensor?.forEach((item) => {
          item.HistoricalValue.forEach((value) => {
            historicalValues.push({
              deviceName: item.SubDeviceName,
              value: value.DecimalVal,
              timestamp: moment(value.Timestamp).format('YYYY-MM-DD hh:mm:ss'),
              unit: value.Unit
            })
          })
        })

        console.log('inimang historical', historicalValues)
        this.tableData = historicalValues

        setTimeout(() => {
          this.createChart(res.data)
          this.loading = false
        }, 2000)
      } catch (err) {
        this.loading = false
      }

      this.loading = false
    },
    async fetchDropdownReport() {
      const res = await this.$axios.get('Sensor/DropdownReport')

      this.dropdownReport = res.data
      // this.dropdownReport = dropdownReportJson

      res.data.forEach((item) => {
        // dropdownReportJson.forEach(item => {
        this.sensorTypeOptions.push({
          value: item.label,
          label: item.value
        })
      })
    },
    onChangePicker() {
      if (this.form.dataForm == 'monthly_avg')
        this.periodDatePickerType = 'month'
      else if (this.form.dataForm == 'yearly_avg')
        this.periodDatePickerType = 'year'
      else this.periodDatePickerType = 'date'

      this.form.startDate = ''
      this.form.endDate = ''
    },
    onChangeTypeSensor() {
      // Find one dropdownReport data which its value equals to form.sensorType
      const selectedDropdownReport = this.dropdownReport.find(
        (item) => item.label === this.form.sensorType
      )
      let index = 1,
        checkboxes = []

      selectedDropdownReport.listSubDevice.forEach((item) => {
        checkboxes.push({
          id: index,
          label: item.subdevice
        })
        index++
      })

      this.checkboxes = checkboxes
    },
    validateDate() {
      if (this.form.startDate != '' && this.form.endDate != '') {
        let temp1 = new Date(this.form.startDate)
        let temp2 = new Date(this.form.endDate)
        if (temp1 > temp2) {
          this.form.endDate = ''
          this.$message.error('End Period must be greater than Start Period')
        }
      }
    },
    CheckedNodes(leafOnly, includeHalfChecked) {
      const indexOfLeaf = this.checkedNodes.indexOf(leafOnly)

      if (indexOfLeaf < 0) {
        this.checkedNodes.push(leafOnly)
      } else {
        this.checkedNodes.splice(indexOfLeaf, 1)
      }
    }
  }
}
</script>
